



















































































import Vue from 'vue';
import StudentLogin from '@/web/components/signup/StudentLogin.vue';
import Signup from '@/web/components/signup/Signup.vue';
import { mapGetters } from 'vuex';
import { getConfig } from '@/web/utils/configuration';
import StudioLogo from '@/web/components/navigation/StudioLogo.vue';
import StudioProductCard from '@/web/components/products/StudioProductCard';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  components: {
    StudioLogo,
    StudioProductCard,
  },
  data() {
    return {
      gift: null,
      giftError: null,
      isLoading: true,
      isClaiming: false,
      status: 'unregister',
    };
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      isLoggedIn: 'user/isLoggedIn',
      user: 'user/user',
      teacher: 'user/teacher',
      userFullName: 'user/userFullName',
    }),
    contents() {
      return {
        unregister: {
          title: this.$t('STUDIO.TITLE.HEY_THERE'),
          description: this.$t(
            'STUDIO.TEXT.YOU_WERE_SENT_A_GIFT_PLEASE_SELECT_ONE',
            {
              name: this.gift.is_anonymous
                ? this.$t('GIFTS.LABELS.SOMEONE')
                : this.gift.gifter_first_name,
            }
          ),
        },
        claim: {
          title: this.$t('STUDIO.TITLE.A_GIFT_IS_WAITING_FOR_YOU'),
          description: this.$t('STUDIO.TEXT.YOU_WERE_SENT_A_GIFT_CLAIM_IT', {
            name: this.gift.is_anonymous
              ? this.$t('GIFTS.LABELS.SOMEONE')
              : this.gift.gifter_first_name,
          }),
        },
      };
    },
    content() {
      return this.contents[this.status];
    },
    giftUuid() {
      return this.$route.params.uuid;
    },
    config() {
      return getConfig();
    },
    studioURL() {
      return getStudioURL(this.$route);
    },
  },
  methods: {
    openLoginModal() {
      this.$modal.show(StudentLogin);
    },
    openRegisterModal() {
      this.$modal.show(Signup, {
        onSignupFn: () => {
          // TODO anything ?
        },
        displayLoginLink: false,
      });
    },
    logout() {
      this.$store.dispatch(`user/logout`);
    },
    async claim() {
      try {
        this.isClaiming = true;
        this.gift = await this.$store.dispatch('studio/acceptGift', {
          studioURL: this.studioURL,
          uuid: this.giftUuid,
        });
        // reload purchased products from backend
        this.$store.dispatch('user/studentPunches');
        this.$store.dispatch('studio/getStudio', this.studioURL);
        // redirect to studio, and invalidate current link
        this.$router.replace({ name: 'studio-dashboard' });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(
            error.response,
            `Failed to accept gift: ${error}`
          ),
          duration: -1, // stay ON
        });
      } finally {
        this.isClaiming = false;
      }
    },
    async loadData() {
      try {
        this.isLoading = true;
        this.gift = await this.$store.dispatch('studio/getGift', {
          studioURL: this.studioURL,
          uuid: this.giftUuid,
        });
      } catch (error) {
        this.giftError = error;
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Gift not found or already claimed',
          duration: -1, // stay ON
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    isLoggedIn: {
      handler: function (isLoggedIn) {
        this.status = isLoggedIn ? 'claim' : 'unregister';
      },
      immediate: true,
    },
  },
});
